import { render, staticRenderFns } from "./bindWechatDetail.vue?vue&type=template&id=819c6734&scoped=true"
import script from "./bindWechatDetail.vue?vue&type=script&lang=js"
export * from "./bindWechatDetail.vue?vue&type=script&lang=js"
import style0 from "./bindWechatDetail.vue?vue&type=style&index=0&id=819c6734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819c6734",
  null
  
)

export default component.exports